import ControlTowerItem from 'core/entities/ControlTowerEntities/ControlTowerItemObject';
class ControlTowerSite {
    constructor (data) {
        if (data) {
            this.id = data.id;
            this.name = data.name;
            this.trustAlertThreshold = data.trust_alert_threshold;
            this.currency = data.currency;
            this.taxMode = data.tax_mode;
            this.comment = data.comment;
            this.items = data.items.map(item => new ControlTowerItem(item));
        }
    }
}

export default ControlTowerSite;
